import React, { useReducer } from "react";
import { Breadcrumb, Row, Col, Form, Input, Button, notification } from "antd";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
const NewComponentFamily = () => {
  const [form] = Form.useForm();
  const [userInput, setUserInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      component_family: "",
    }
  );

  const handleChange = (e) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });
  };
  const openNotification = (type) => {
    notification[type]({
      message: "Component Family Added",
      description: "Component Family added successfully",
    });
  };
  const FailNotification = (type) => {
    notification[type]({
      message: "Error",
      description: "Please Fill out Required Fields",
    });
  };
  const onFinish = (values) => {
    console.log(values);
  };
  const onReset = () => {
    form.resetFields();
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (userInput.component_family !== "") {
      axios
        .post(`${getServerUrl()}/master/createcomponentfamily`, userInput, {
          headers: { "x-auth-token": localStorage.getItem("token") },
        })
        .then((res) => {
          const data = res.data;
          //console.log(data);
          if (data.success === 1) {
            setUserInput({
              component_family: "",
            });
            openNotification("success");
          } else {
          }
        });
    } else {
      FailNotification("error");
    }
  };
  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
        <Breadcrumb.Item>Components Settings</Breadcrumb.Item>
        <Breadcrumb.Item>Create New Component Family</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background">
        <h2 className="titles">
          CREATE NEW <span>COMPONENT FAMLILY</span>
        </h2>

        <Row>
          <Col span={16}>
            <h2>Component Family Name</h2>
            <label>RM TYPE</label>
            <Input
              name="component_family"
              value={userInput.component_family}
              onChange={handleChange}
              rules={[
                {
                  required: true,
                  message: "Please enter username!",
                },
              ]}
            />

            <br></br>
            <br></br>
            <Button
              type="primary"
              shape="round"
              size="large"
              onClick={handleSubmit}
            >
              Add
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default NewComponentFamily;
